import { useRouter } from 'next/router';
import { InnerFeedContext } from '@interfaces/models/elasticSearch';

const useDealHuntingSearchParams = (innerFeedContext: InnerFeedContext) => {
  const { query } = useRouter();
  const priceDropProductID =
    innerFeedContext === InnerFeedContext.DealHunting ? query?.notificationProductId : undefined;

  return { priceDropProductID };
};

export default useDealHuntingSearchParams;
